import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { ShareResourceExample } from './shareResourceBannerTypes';

interface ShareResourceBannerExamplesProps {
  examples: readonly ShareResourceExample[];
}

const ShareResourceBannerExamples = ({ examples }: ShareResourceBannerExamplesProps) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
      {examples.map(({ Icon, titleKey, detailKey }) => (
        <Box
          key={titleKey}
          sx={{ alignItems: 'center', display: 'flex', gap: 1.25, p: 1 }}
        >
          <Box
            aria-hidden
            sx={{
              alignItems: 'center',
              backgroundColor: theme.brandV2.colors.treadGray8,
              borderRadius: 2,
              color: theme.brandV2.colors.treadGray3,
              display: 'flex',
              flexShrink: 0,
              height: 30,
              justifyContent: 'center',
              width: 30,
            }}
          >
            <Icon sx={{ fontSize: 16 }} />
          </Box>
          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            <Typography
              variant="body2"
              sx={{ color: theme.brandV2.colors.treadGray1, fontWeight: 600 }}
            >
              {t(titleKey)}
            </Typography>
            <Typography variant="body2" sx={{ color: theme.brandV2.colors.treadGray2 }}>
              {t(detailKey)}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default ShareResourceBannerExamples;
